module.exports = __webpack_public_path__ + "static/7-714e708edae9e01a00e51ddeafb80645.jpg";